import { useId } from "react";
import type { IconProps } from "./types";

type Props = IconProps & {
  color1?: string;
  color2?: string;
  showLinerGradient?: boolean;
};

const Person = ({
  width,
  height,
  color1 = "#FFF500",
  color2 = "#FFBB0C",
  showLinerGradient = true,
  ...props
}: Props) => {
  const gradientId = useId();
  const maskId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <defs>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(17.743 28.6639 -36.5026 59.6257 7.49958 6.60952)"
          gradientUnits="userSpaceOnUse"
        >
          {showLinerGradient && <stop stopColor="white" />}
          <stop offset="0.42" stopColor={color1} />
          <stop offset="0.97" stopColor={color2} />
        </radialGradient>
        <mask id={maskId}>
          <rect width="32" height="32" fill="white" />
          <path
            d="M15.9998 15.1667C17.8408 15.1667 19.3332 13.6743 19.3332 11.8333C19.3332 9.99238 17.8408 8.5 15.9998 8.5C14.1589 8.5 12.6665 9.99238 12.6665 11.8333C12.6665 13.6743 14.1589 15.1667 15.9998 15.1667Z"
            fill="black"
          />
          <path
            d="M20.9998 23.5002C21.4601 23.5002 21.8332 23.1271 21.8332 22.6668C21.8332 19.4452 19.2215 16.8335 15.9998 16.8335C12.7782 16.8335 10.1665 19.4452 10.1665 22.6668C10.1665 23.1271 10.5396 23.5002 10.9998 23.5002H20.9998Z"
            fill="black"
          />
        </mask>
      </defs>
      <rect
        width="32"
        height="32"
        rx="16"
        fill={`url(#${gradientId})`}
        mask={`url(#${maskId})`}
      />
    </svg>
  );
};

export default Person;
